import { getMemberTypeLabel } from "../MemberType";

export default function Totals({ total = 0, tickets = [] }) {
  if (!Array.isArray(tickets) || tickets.length === 0) {
    return null;
  }

  return (
    <div className="totals">
      <div className="totals__table">
        <tr>
          <th>Item</th>
          <th>Subtotal</th>
        </tr>
        {tickets.map((ticket, idx) => (
          <tr key={ticket.id ?? idx}>
            <td>
              {getMemberTypeLabel(ticket.member_type)} Ticket <strong>× 1</strong>
            </td>
            <td>${ticket.price != null && ticket.price !== "" ? Number(ticket.price) || 0 : "--"}</td>
          </tr>
        ))}
        <tr>
          <td>
            <strong>Total</strong>
          </td>
          <td>
            <strong>${Number(total) || 0}</strong>
          </td>
        </tr>
      </div>
    </div>
  );
}
